import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72102861"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ncgr-heading -size-s ncgr-mar-b-8 heading" }
const _hoisted_2 = { class: "ncgr-card ncgr-card--rounded-to-normal" }
const _hoisted_3 = { class: "ncgr-container ncgr-pad-t-24 ncgr-pad-b-24" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ncgr-icon",
    "data-icon": "pencil"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "shipping-address"
}
const _hoisted_8 = { class: "ncgr-mar-b-16" }
const _hoisted_9 = { class: "ncgr-row" }
const _hoisted_10 = { class: "ncgr-col -col-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "shipping-address-last-name"
}, " 姓 ", -1))
const _hoisted_12 = { class: "_control" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "ncgr-col -col-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "shipping-address-first-name"
}, " 名 ", -1))
const _hoisted_16 = { class: "_control" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "ncgr-mar-b-16" }
const _hoisted_19 = { class: "ncgr-mar-b-16" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "shipping-address-prefecture-code"
}, "都道府県", -1))
const _hoisted_21 = { class: "_control" }
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 0,
  class: "ncgr-tooltip -top -active",
  role: "tooltip"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_trailing" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_icon" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "ncgr-icon",
      "data-icon": "arrow_drop_down"
    })
  ])
], -1))
const _hoisted_25 = { class: "ncgr-mar-b-16" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "shipping-address-address1"
}, " 市区町村 ", -1))
const _hoisted_27 = { class: "_control" }
const _hoisted_28 = {
  key: 0,
  id: "addresses"
}
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 1,
  class: "ncgr-tooltip -top -active",
  role: "tooltip"
}
const _hoisted_31 = { class: "ncgr-mar-b-16" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "shipping-address-address2"
}, " 番地 ", -1))
const _hoisted_33 = { class: "_control" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "ncgr-text-field ncgr-mar-b-16" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "shipping-address-address3"
}, " 建物名・部屋番号 ", -1))
const _hoisted_37 = { class: "_control" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "ncgr-mar-b-16" }
const _hoisted_40 = { class: "ncgr-mar-b-16" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "purchaser-email"
}, " メールアドレス ", -1))
const _hoisted_42 = { class: "_control" }
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "ncgr-interactive-list" }
const _hoisted_45 = { class: "_item" }
const _hoisted_46 = { for: "shipping-address-remember" }
const _hoisted_47 = { class: "_leading" }
const _hoisted_48 = { class: "_input" }
const _hoisted_49 = ["checked"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_title" }, " お届け先を登録する ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_FormattableField = _resolveComponent("FormattableField")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.showRegisteredAddress ? 'お届け先' : 'お届け先を入力'), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showRegisteredAddress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", null, " 〒" + _toDisplayString(_ctx.address.zipCode), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.prefectureName) + _toDisplayString(_ctx.address.address1) + _toDisplayString(_ctx.address.address2) + _toDisplayString(_ctx.address.address3), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.address.lastName) + " " + _toDisplayString(_ctx.address.firstName), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.address.phone), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.address.purchaserEmail), 1),
              _createElementVNode("button", {
                class: "ncgr-button -appearance-flat shipping-address-edit-button",
                "data-test": "edit-address",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showRegisteredAddress = false))
              }, _hoisted_6)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Field, {
                      name: "last-name",
                      rules: "required"
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["ncgr-text-field", { '-color-negative': errors[0] }])
                        }, [
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("input", _mergeProps({
                              class: "_input",
                              type: "text"
                            }, field, {
                              id: "shipping-address-last-name",
                              autocomplete: "family-name",
                              value: _ctx.address.lastName,
                              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitInput($event.target.value, 'lastName')))
                            }), null, 16, _hoisted_13)
                          ])
                        ], 2)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      name: "first-name",
                      rules: "required"
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["ncgr-text-field", { '-color-negative': errors[0] }])
                        }, [
                          _hoisted_15,
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("input", _mergeProps({
                              class: "_input",
                              type: "text"
                            }, field, {
                              id: "shipping-address-first-name",
                              autocomplete: "given-name",
                              value: _ctx.address.firstName,
                              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitInput($event.target.value, 'firstName')))
                            }), null, 16, _hoisted_17)
                          ])
                        ], 2)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_FormattableField, {
                  label: "郵便番号",
                  type: "tel",
                  name: "zip-code",
                  class: "_input",
                  id: "shipping-address-zip-code",
                  autocomplete: "postal-code",
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitInput($event, 'zipCode'))),
                  validator: "required",
                  initValue: _ctx.address.zipCode,
                  format: _ctx.formatZipCode
                }, null, 8, ["initValue", "format"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: _normalizeClass(["ncgr-text-field", { '-color-negative': _ctx.prefErrors[0] }])
                }, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _withDirectives(_createElementVNode("select", {
                      id: "shipping-address-prefecture-code",
                      name: "shipping-address-prefecture-code",
                      class: "_input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.prefField) = $event)),
                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleChangePref && _ctx.handleChangePref(...args)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prefectures, (pref) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: pref.code,
                          value: pref.code
                        }, _toDisplayString(pref.name), 9, _hoisted_22))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.prefField]
                    ]),
                    (_ctx.prefErrors[0])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 郵便番号と都道府県が一致していません "))
                      : _createCommentVNode("", true),
                    _hoisted_24
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", {
                  class: _normalizeClass(["ncgr-text-field", { '-color-negative': _ctx.addressErrors[0] }])
                }, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _withDirectives(_createElementVNode("input", _mergeProps({
                      class: "_input",
                      type: "text",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addressField) = $event)),
                      id: "shipping-address-address1"
                    }, _ctx.address.suggestion ? { list: 'addresses' } : {}, {
                      autocomplete: "address-line1",
                      onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.emitInput($event.target.value, 'address1'))),
                      onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validateAddressField()))
                    }), null, 16), [
                      [_vModelText, _ctx.addressField]
                    ])
                  ]),
                  (_ctx.address.suggestion)
                    ? (_openBlock(), _createElementBlock("datalist", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.address.suggestion.addresses, (address) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: address,
                            value: address
                          }, _toDisplayString(address), 9, _hoisted_29))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.addressErrors[0] && _ctx.addressErrors[0].includes('not matched'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, " 郵便番号と市区町村が一致していません "))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_Field, {
                  name: "address2",
                  rules: "required"
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["ncgr-text-field", { '-color-negative': errors[0] }])
                    }, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("input", _mergeProps({
                          class: "_input",
                          type: "text"
                        }, field, {
                          id: "shipping-address-address2",
                          autocomplete: "address-line2",
                          value: _ctx.address.address2,
                          onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.emitInput($event.target.value, 'address2')))
                        }), null, 16, _hoisted_34)
                      ])
                    ], 2)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("input", {
                    class: "_input",
                    type: "text",
                    id: "shipping-address-address3",
                    autocomplete: "address-line3",
                    value: _ctx.address.address3,
                    onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.emitInput($event.target.value, 'address3')))
                  }, null, 40, _hoisted_38)
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_FormattableField, {
                  label: "電話番号",
                  type: "tel",
                  name: "phone",
                  class: "_input",
                  id: "shipping-address-phone",
                  autocomplete: "phone-full",
                  onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.emitInput($event, 'phone'))),
                  initValue: _ctx.address.phone,
                  validator: _ctx.validatePhoneNumber,
                  format: _ctx.formatPhoneNumber
                }, null, 8, ["initValue", "validator", "format"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_Field, {
                  name: "purchaser-email",
                  rules: "required|email"
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["ncgr-text-field", { '-color-negative': errors[0] }])
                    }, [
                      _hoisted_41,
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("input", _mergeProps({
                          class: "_input",
                          type: "email",
                          id: "purchaser-email"
                        }, field, {
                          autocomplete: "email",
                          value: _ctx.address.purchaserEmail,
                          onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.emitInput($event.target.value, 'purchaserEmail')))
                        }), null, 16, _hoisted_43)
                      ])
                    ], 2)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("input", {
                          class: "ncgr-checkbox",
                          type: "checkbox",
                          name: "shipping-address-remember",
                          id: "shipping-address-remember",
                          checked: _ctx.address.remember,
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.emitCheckboxInput($event, 'remember')))
                        }, null, 40, _hoisted_49)
                      ])
                    ]),
                    _hoisted_50
                  ])
                ])
              ])
            ]))
      ])
    ])
  ]))
}